import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import searchIcon from "../../assets/icons/Vector.svg";
const filter = createFilterOptions();

export default function FreeSoloCreateOption({
  options,
  value,
  setValue,
  width,
  float,
  marginLeft,
  onSelection,
  loading = false,
}) {
  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        if (typeof newValue === "string") {
          setValue({
            title: newValue,
          });
        } else if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          setValue({
            title: newValue.inputValue,
          });
        } else {
          setValue(newValue);
          // Call the selection callback if provided
          if (onSelection && newValue) {
            onSelection(newValue);
          }
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;
        // Suggest the creation of a new value
        const isExisting = options.some(
          (option) => inputValue === option.title
        );
        if (inputValue !== "" && !isExisting) {
          filtered.push({
            inputValue,
            title: `All results for "${inputValue}"`,
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id="free-solo-with-text-demo"
      options={options.options}
      loading={loading}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === "string") {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.title;
      }}
      renderOption={(props, option) => <li {...props}>{option.title}</li>}
      sx={{ width: "auto" }}
      freeSolo
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search..."
          label=""
          variant="outlined"
          sx={{
            float: float ? float : "",
            width: width ? width : "44%",
            "& .MuiInputBase-root": { padding: "5px 20px" },
            //    marginBottom: "16px",
            marginLeft: marginLeft ? marginLeft : "0px",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              "&.Mui-focused": {
                borderColor: "green", // Example focused border color
              },
            },
            "& .MuiInputLabel-root": {
              color: "blue", // Example label color
            },
          }}
          InputProps={{
            ...params.InputProps,
            //  onClick: () => setValue({ title: "" }),
            startAdornment: (
              <img style={{ padding: "0px 5px 0px 0px" }} src={searchIcon} draggable={false} alt=""/>
            ),
          }}
        />
      )}
    />
  );
}
